import React from 'react';
import Tab from './parts/Tab';
import {TabType} from '../../../components/slides/form/part/tabs';

interface TabsProps {
    tabs: TabType[];
    activeTab: string;
    setActiveTab: (id: string) => void;
    secondary?: boolean;
    ignore?: string[];
}

export default function Tabs(props: Readonly<TabsProps>): JSX.Element {
    const {tabs, activeTab, setActiveTab, secondary = false, ignore = []} = props;

    return (
        <nav className={`c-tabContainer ${secondary ? 'c-tabContainer--secondary' : ''}`}>
            {tabs.map((tab) => {
                if (ignore.includes(tab.id)) return null;

                return <Tab key={tab.id + tab.label} tab={tab} active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)} />;
            })}
        </nav>
    );
}
